module.exports = __webpack_public_path__ + "static/006_001-6b2c342a8fa7817c919ffdb233c73000.jpg";